<template>
  <div class="container">
    <div class="mx-auto" style="max-width: 400px">
      <div v-if="validar_pin">
        <p>
          Enviamos uma mensagem com um PIN de 6 dígitos para {{ destinoRecuperacao }}: <b>{{dataUser.email | maskPhone}}</b> <a href="javascript:" @click="clearMensagem(true)" v-if="!dataUser.id_cliente">(alterar)</a>
        </p>
        <p class="small">
          Não recebeu? <br>
          <span v-if="segundos <= 0"><a href="javascript:" @click="clearMensagem()">Enviar novamente</a></span>
          <span v-else>Você pode enviar novamente em <b>{{ segundos }}</b> segundos.</span>
        </p>
        <aviso-informativo variante="cinza" :mostrar-icone="false" class="small mb-3">{{ mensagemCanal }}</aviso-informativo>
        <div class="form-group mb-2">
          <label class="mb-0 font-weight-bold small">Digite o PIN *</label>
          <the-mask id="validar_cod_pin" :mask="['#-#-#-#-#-#']" class="form-control" type="tel"
                    autocomplete="one-time-code" placeholder="#-#-#-#-#-#" v-model="pin"/>
        </div>
        <button class="btn btn-primary btn-block mb-3" @click="verificarPin(true)" :disabled="pin.length < 6 || load">
          <span v-show="load"><i class="fa fa-spinner fa-pulse"></i> Aguarde</span>
          <span v-show="!load">Avançar</span>
        </button>
      </div>

      <div v-else>
        <form @submit.prevent="solicitarUsuario">
          <div class="form-group mt-2 mb-2">
            <label class="mb-0 font-weight-bold small">Senha *</label>
            <input type="password" id="senha_troca" class="form-control" placeholder="Senha (mínimo 6 dígitos)" minlength="6" v-model="usuario.senha" required maxlength="100">
          </div>
          <div class="form-group mb-1">
            <label class="mb-0 font-weight-bold small">Confirmar senha *</label>
            <input type="password" class="form-control" placeholder="Confirme sua senha" minlength="6" v-model="confirmarSenha" required maxlength="100">
          </div>
          <button class="btn btn-primary btn-block mt-3 mb-3">
            <span v-show="load"><i class="fa fa-spinner fa-pulse"></i> Aguarde</span>
            <span v-show="!load">Trocar senha</span>
          </button>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import AvisoInformativo from "./AvisoInformativo";
  import {TheMask} from 'vue-the-mask';

  export default {
    name: 'TrocaSenha',
    components: {AvisoInformativo,  TheMask },
    props: ['dataUser'],
    data() {
      return {
        load: false,
        usuario:  {
          senha: '',
          token: ''
        },
        url: '',
        pin: '',
        validar_pin: true,
        confirmarSenha: '',
        solicitou: false,

        ac: null,
        segundos: 60,
        interval: null,
      }
    },

    methods: {
      solicitarUsuario() {
        if (this.usuario.senha !== this.confirmarSenha) {
          this.$swal("As senhas não correspondem.");
          return;
        }

        this.load = true;
        this.usuario.token = this.pin;

        this.$http.post(this.$store.state.base_url + 'cliente/recuperar-senha', this.usuario)
          .then(res => {
            if (res && res.data.success) {
              this.$swal("Sua senha foi alterada com sucesso. Faça o login para continuar.").then(() => {
                this.$router.push(this.url + '/perfil/login');
              });

            } else {
              this.$swal("Não foi possível recuperar sua senha. Entre em contato com nosso suporte pelo email: contato@storkdigital.com.br");
            }

            this.load = false;

          }, res => {
            this.load = false;
            console.log(res);
            this.$swal(res.data && res.data.msg ? res.data.msg : 'Erro temporário');
          });
      },

      verificarPin() {
        if (this.load || this.pin.length < 6) {
          return;
        }

        this.load = true;
        const dados = { pin: this.pin };
        const contato = ((this.dataUser.email || '') + '').trim();

        if (this.dataUser.id_cliente) {
          dados.id_cliente = this.dataUser.id_cliente;
        }

        if (contato && !isNaN(contato)) {
          dados.telefone = contato.replace(/\D/g, '');
        }

        this.$http.post(this.$store.state.base_url + 'cliente/validar-pin', dados)
          .then(res => {
            if (res.data.success) {
              this.validar_pin = false;
              this.$nextTick(() => {
                this.$helpers.focusrElement('senha_troca');
              });

            } else {
              this.$swal('O PIN informado está incorreto, por favor verifique novamente o codigo enviado!').then(() => {
                this.$helpers.focusrElement('validar_cod_pin');
              })
            }

            this.load = false;

          }, res => {
            this.load = false;
            console.log(res);
            this.$swal(res.data && res.data.msg ? res.data.msg : 'Erro temporário');
          });
      },

      clearMensagem(force) {
        if (force || this.segundos <= 0) {
          this.$emit('reenviar', !force);
        }
      },

      countDown() {
        clearInterval(this.interval);
        this.segundos = 60;
        this.interval = setInterval(() => {
          this.segundos = this.segundos - 1;

          if (this.segundos < 0) {
            clearInterval(this.interval);
          }
        }, 1000);
      },
    },

    mounted() {
      window.scrollTo(0,0);
      this.url = this.$helpers.getUrlApp(this.$route.params.id || '');
    },

    created() {
      this.$parent.$on('trocarSenha', (h) => {
        this.countDown();
      });

      if ('OTPCredential' in window) {
        navigator.credentials.get({
          otp: { transport:['sms'] }
        }).then(otp => {
          this.pin = otp.code;
          this.verificarPin();

        }).catch(err => {
          console.log(err);
        });
      }
    },

    computed: {
      destinoRecuperacao() {
        switch (this.dataUser.canal_recuperacao) {
          case 'email':
            return 'ao e-mail';
          case 'whatsapp':
            return 'ao WhatsApp';
          default:
            return 'ao número';
        }
      },

      mensagemCanal() {
        switch (this.dataUser.canal_recuperacao) {
          case 'email':
            return 'Por favor aguarde, pode levar alguns segundos para o e-mail chegar.';
          case 'whatsapp':
            return 'Por favor aguarde, pode levar alguns segundos para a mensagem chegar no WhatsApp.';
          default:
            return 'Por favor aguarde, pode levar alguns segundos para o SMS chegar.';
        }
      }
    }
  }
</script>
